import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import Layout from '../../components/Layout';
import Link from '@mui/material/Link';
import Social from '../../components/social/Social';

function Home() {
  return (
    <Layout>
      <Helmet>
        <title>About — Rojan Thomas</title>
        <meta name="description" content="Rojan Thomas — Senior Software Engineer at Tesco with over 10 years of experience." />
      </Helmet>
      {/* Page title */}
      <Box
        sx={{
          marginBottom: 4,
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '1.1rem', sm: '1.25rem' },
            fontWeight: 500,
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          }}
        >
          About
        </Typography>
      </Box>

      {/* Intro content */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        {/* Android Mascot - Official Bugdroid */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 2,
          }}
        >
          <img
            src="/Android_robot.svg.png"
            alt="Android Robot"
            style={{
              width: '80px',
              height: 'auto',
              filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))',
            }}
          />
        </Box>

        <Typography
          variant="body1"
          sx={{
            color: 'text.primary',
            lineHeight: 1.5,
            fontSize: '0.95rem',
          }}
        >
          Hi! I'm Rojan Thomas, a Senior Software Engineer (Android) at{' '}
          <Link
            href="https://www.tesco.com/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'text.primary',
              textDecoration: 'underline',
              '&:hover': {
                opacity: 0.6,
              },
            }}
          >
            Tesco
          </Link>
          . I have over 10 years of experience working with Android and software development.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            lineHeight: 1.5,
            fontSize: '0.95rem',
          }}
        >
          I'm passionate about all things technology and love to learn new things. I also like working on cars and fixing them up.
        </Typography>

        {/* Social links */}
        <Box sx={{ marginTop: 6 }}>
          <Social />
        </Box>
      </Box>
    </Layout>
  );
}

export default Home;
